import { useCallback, useContext } from 'react';
import notification from './notification';
import { addNotification } from './NetworkErrorNotificationSingleton';
import getMessagesByKeys from './i18n/getMessagesByKeys';
import UnauthenticatedRouteLanguageContext from './UnauthenticatedRouteLanguageContext';
import AuthenticatedRouteLanguageContext from './AuthenticatedRouteLanguageContext';
import useIsAuthenticatedRoute from './useIsAuthenticatedRoute';

const MESSAGE_KEYS = [
    'error_notification.network_error_title',
    'error_notification.network_error_description',
];

export default function useNetworkErrorNotification() {
    const authenticatedPath = useIsAuthenticatedRoute();
    const { messageLanguage } = useContext(
        authenticatedPath ? AuthenticatedRouteLanguageContext : UnauthenticatedRouteLanguageContext,
    );

    const showNotification = useCallback(async () => {
        const [networkErrorTitle, networkErrorDescription] = await getMessagesByKeys(
            MESSAGE_KEYS,
            messageLanguage,
        );

        const notificationId = notification.error(networkErrorTitle, networkErrorDescription);
        addNotification(notificationId);
    }, [messageLanguage]);

    return { showNotification };
}
